import React, { useCallback, useState } from "react";
import {
  Table,
  Button,
  Space,
  Modal,
  Form,
  Input,
  notification,
  Tag,
} from "antd";
import {
  searchGateway,
  deleteGateway,
  createGateway,
  updateGateway,
  SearchParams,
} from "../../api/gateway";
import { useRequest } from "../../hooks";
import { textRender } from "../../utils";
import LocaltionSelect from "../common/LocationSelect";
import { useNavigate } from "react-router-dom";
import IfNotObserver from "../common/IfNotObserver";

// eslint-disable-next-line import/no-anonymous-default-export
export default function () {
  const [showModal, setShowModal] = React.useState(false);
  const [, setRefreshKey] = useState(Symbol());
  const [searchParams, setSearchParams] = useState<Partial<SearchParams>>({
    pageSize: 10,
    pageNum: 1,
  });
  const [edittingRecord, setEdittingRecord] = useState<Gateway>();
  const fetchData = useCallback(() => {
    return searchGateway(searchParams);
  }, [searchParams]);
  const { data, loading } = useRequest(fetchData);
  const isUpdate = Boolean(edittingRecord?.gatewayId);
  const [keywords, setKeywords] = useState("");
  const navigate = useNavigate();
  return (
    <div>
      <Space style={{ display: "flex", justifyContent: "space-between" }}>
        <Space>
          <Input
            allowClear
            value={keywords}
            onKeyUp={(e) => {
              if (e.key === "Enter") {
                setSearchParams({
                  ...searchParams,
                  queryName: e.currentTarget.value,
                  queryMac: "",
                });
              }
            }}
            onChange={(e) => {
              setKeywords(e.target.value);
              if (!e.target.value) {
                setSearchParams({
                  ...searchParams,
                  queryName: "",
                  queryMac: "",
                });
              }
            }}
            placeholder="请输入检索内容"
          />
          <Button.Group>
            <Button
              onClick={() => {
                setSearchParams({
                  ...searchParams,
                  queryName: keywords,
                  queryMac: "",
                });
              }}
              type="primary"
            >
              按网关名称检索
            </Button>
            <Button
              onClick={() => {
                setSearchParams({
                  ...searchParams,
                  queryMac: keywords,
                  queryName: "",
                });
              }}
            >
              按MAC地址检索
            </Button>
          </Button.Group>
        </Space>
        <IfNotObserver>
          <Button
            type="primary"
            onClick={() => {
              setEdittingRecord({} as Gateway);
              setShowModal(true);
            }}
          >
            创建网关
          </Button>
        </IfNotObserver>
      </Space>
      <br /> <br />
      <Table
        loading={loading}
        pagination={{
          total: data?.total,
          pageSize: searchParams.pageSize,
          current: searchParams.pageNum,
          onChange(pageNum) {
            setSearchParams({
              ...searchParams,
              pageNum,
            });
          },
        }}
        onRow={(row) => {
          return {
            onClick() {
              navigate(`./${row.mac}?gatewayName=${row.name}`);
            },
          };
        }}
        columns={[
          {
            dataIndex: "name",
            title: "网关名称",
            sorter: (a, b) => a.name.localeCompare(b.name),
            sortDirections: ['ascend', 'descend'],
            defaultSortOrder: 'ascend', // 设置默认升序
          },
          {
            dataIndex: "organizationName",
            title: "展馆",
            render: textRender,
          },
          {
            dataIndex: "mac",
            title: "MAC地址",
            render: textRender,
          },
          {
            dataIndex: "status",
            title: "网关状态",
            render: (status) => {
              return status === 1 ? (
                <Tag color="green">正常</Tag>
              ) : (
                <Tag color="red">离线</Tag>
              );
            },
          },
          {
            dataIndex: "description",
            title: "备注",
            render: textRender,
          },
          {
            dataIndex: "createDatetime",
            title: "创建时间",
            render: (_, row) => textRender(row.createdUser?.createDatetime),
          },
          {
            dataIndex: "createdBy",
            title: "创建人",
            render: (_, row) => textRender(row.createdUser?.userName),
          },
          {
            dataIndex: "actions",
            title: "操作",
            render: (_, row) => {
              return (
                <Space size="middle">
                  <IfNotObserver>
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setEdittingRecord(row);
                        setShowModal(true);
                      }}
                    >
                      编辑
                    </a>
                  </IfNotObserver>

                  <a
                    onClick={(e) => {
                      navigate(`./${row.mac}?gatewayName=${row.name}`);
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                  >
                    详情
                  </a>
                  <IfNotObserver>
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        Modal.confirm({
                          title: "确定删除?",
                          onOk: () => {
                            deleteGateway(row.gatewayId)
                              .then(() => {
                                notification.success({ message: "删除成功" });
                                setRefreshKey(Symbol());
                              })
                              .catch(() => {
                                notification.error({
                                  message: "删除失败,请重试",
                                });
                              });
                          },
                        });
                      }}
                    >
                      删除
                    </a>
                  </IfNotObserver>
                </Space>
              );
            },
          },
        ]}
        dataSource={data?.data}
      />
      <Modal
        destroyOnClose
        title={`${isUpdate ? "更新" : "创建"}网关`}
        open={showModal}
        footer={null}
        onCancel={() => {
          setShowModal(false);
        }}
      >
        <br />
        <Form
          initialValues={edittingRecord}
          onFinish={(values) => {
            const payload = {
              ...edittingRecord,
              ...values,
            };
            const method = isUpdate ? updateGateway : createGateway;
            method(payload)
              .then(() => {
                notification.success({
                  message: `${isUpdate ? "更新" : "创建"}成功`,
                });
                setSearchParams({
                  ...searchParams,
                  pageNum: 1,
                });
                setEdittingRecord(undefined);
                setShowModal(false);
              })
              .catch((err: any) => {
                notification.error({
                  message:
                    err.message || `${isUpdate ? "更新" : "创建"}失败,请重试`,
                });
              });
          }}
          {...{
            labelCol: { span: 4 },
            wrapperCol: { span: 20 },
          }}
        >
          <Form.Item
            name="organizationId"
            label="展馆"
            rules={[{ required: true }]}
          >
            <LocaltionSelect />
          </Form.Item>
          <Form.Item name="name" label="名称" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="mac" label="MAC地址" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="description" label="备注">
            <Input.TextArea />
          </Form.Item>
          <Form.Item style={{ textAlign: "center" }}>
            <Button htmlType="submit" type="primary">
              确认
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}
